export const CUSTOM_WORKFLOW_INFO_DISMISS = 'CUSTOM_WORKFLOW_INFO_DISMISS';
export const REMOVE_WORKFLOW_LIST_FILTER = 'REMOVE_WORKFLOW_LIST_FILTER';
export const FILTER_WORKFLOW_LIST_BY_EDITABLE =
  'FILTER_WORKFLOW_LIST_BY_EDITABLE';

export function dismissCustomWorkflowInfo() {
  return { type: CUSTOM_WORKFLOW_INFO_DISMISS };
}

export function removeWorkflowListFilter() {
  return { type: REMOVE_WORKFLOW_LIST_FILTER };
}

export function filterWorkflowListByEditable() {
  return { type: FILTER_WORKFLOW_LIST_BY_EDITABLE };
}
